import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpClient } from '@angular/common/http';
import { Action, Store } from '@ngrx/store';
import {catchError, concatMap, map, switchMap, withLatestFrom, tap} from 'rxjs/operators';
import {EMPTY, Observable, of} from 'rxjs';
import { PurchaseActionTypes, PurchaseActions } from '../actions/purchase.actions';
import * as featureActions from '../../index';
import * as fromStore from '../../../store';
import { PurchaseService} from '../../../services/purchse.service';

@Injectable()
export class PurchaseEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private purchaseService = inject(PurchaseService);
  private http = inject(HttpClient);

  constructor() {}

  ReadPurchaseHistory$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.PurchaseActionTypes.GET_PURCHASE),
    map((action: featureActions.GetPurchaseAction) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      // 創建新對象副本以避免修改只讀的 action payload (NgRx 9 immutability)
      const enrichedPayload = { ...payload, otp: user.otp, acode: user.acode };
      return this.purchaseService.ReadPurchaseHistory(enrichedPayload).pipe(
        map((res: any) => {
          if (res.result || Array.isArray(res.msg.body)) {
            return new featureActions.GetPurchaseSuccessAction(res.msg.body);
          } else {
            return new featureActions.GetPurchaseFailAction();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetPurchaseFailAction());
        })
      );
    })
  ));
  ReadPurchaseOtp$ = createEffect(() => this.actions$.pipe(
    ofType(PurchaseActionTypes.GET_PURCHASE_OTP),
    switchMap((action: any) => {
      return this.purchaseService.ReadPurchaseOtp(action.payload).pipe(
        map((res: any) => {
          if (res.result) {
            return new featureActions.GetPurchaseOtpSuccessAction(res.msg.body);
          } else {
            return new featureActions.GetPurchaseOtpFailAction();
          }
        }),
        catchError(error => {
          return of(new featureActions.GetPurchaseOtpFailAction());
        })
      );
    })
  ));
  createPayPalUrl$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.PurchaseActionTypes.GetPayPalAgreementApprovalUrl),
    switchMap((action: any) => {
      const param = action.payload;
      return this.purchaseService.CreatePayPalAgreement(param).pipe(
        map((res: any) => {
          if (res && res.approval_url) {
            return new featureActions.GetPayPalAgreementApprovalUrlSuccess(res);
          } else {
            return new featureActions.GetPayPalAgreementApprovalUrlFailure({ error: res.errmsg });
          }
        }),
        catchError(error => {
          return of(new featureActions.GetPayPalAgreementApprovalUrlFailure({ error: error.errmsg }));
        })
      );
    })
  ));
}
